import type { FaireProductEntity } from "../../entity_types/product";

export const p_uq2vxsa7de: FaireProductEntity = {
  token: "p_uq2vxsa7de",
  type: "product",
  name: "Color Garden Stone Beaded Stretch Bracelet",
  brandToken: "b_eow5j1bbc8",
  brandName: "Ellison+Young",
  imageUrl:
    "https://cdn.faire.com/fastly/9daa2052d748268db438ee5e1c65bc0155465aba874055c309a8ea987d08a214.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/055e0816cf8a8ba6dd082aa8587b6294829c9a586f9bfd957bf6090b14f4d5fa.jpeg",
  ],
  priceDollars: 6.5,
  description:
    'A joyful blend of color and texture, the Color Garden Stone Beaded Stretch Bracelet brings a fresh, effortless charm to your everyday stack. Featuring softly polished stone beads in a harmonious mix of hues, this bracelet adds a natural pop of color that feels both playful and refined.\n\n• Colorful Stone Beads – A vibrant mix of tones inspired by a blooming garden\n• Naturally Chic Design – Effortless style that pairs beautifully with any look\n• Easy Stretch Fit – Comfortable slip-on style, perfect for layering or wearing solo\n\nDimensions: Approximately 3" diameter before stretch\nMaterials: Natural stone beads\nFeatures: Hypoallergenic, lead & nickel free, made for comfortable everyday wear\nImported',
  tags: [],
  msrpDollars: 16.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:59.023Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
